import styled from '@emotion/styled';
import { Divider as _Divider } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { SPACING_UNIT } from '../../../constant/spacing';
import Field from './DummyField';
import _Section from './DummySection';

interface Props {
  className?: string;
}

const DummyCreativeBriefDetail = ({ className }: ClassAttributes<HTMLElement> & Props) => (
  <div className={className}>
    <Section>
      <Field />

      <Field />

      <Field />
    </Section>

    <Divider />

    <Section>
      <Field />

      <Field />

      <Field />
    </Section>

    <Divider />

    <Section>
      <Field />

      <Field />

      <Field />
    </Section>
  </div>
);

const Section = styled(_Section)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

const Divider = styled(_Divider)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

export default DummyCreativeBriefDetail;
